import { useState, useEffect, useContext, useRef } from 'react';
import "../css/Modal.css"
import UserContext from "../contexts/UserContext";
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import { emailRegex, scrollToTop } from "../utils/helper.js";
import FetchUtil from "../utils/FetchUtil";
import { ddStyles } from "../utils/CommonStyles.js";

let companyOptions = [];
let timezoneOptions = [];
let countryOptions = [];
let stateOptions = [];
let userSubTypeOptions = [];
let defCountryText = "Select Country";

function UserModal({ key, t, user, setShow, refetch, add, roles, appNames }) {
    const [states, setStates] = useState([]);
    //const [countries, setCountries] = useState([]);
    const [interests, setInterests] = useState([]);
    const [companyGroups, setCompanyGroups] = useState([]);
    const [error, setError] = useState("");
    //const [timezones, setTimezones ] = useState([]);
    const [formErrors, setFormErrors] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const userCtx = useContext(UserContext);
    const navigate = useNavigate();
    const [stateSelected, setStateSelected] = useState({ name: "stateKey", label: (user.stateName), value: (user.stateKey + "-" + user.stateCode) });
    const [roleValue, setRoleValue] = useState(user.roleKey + "-" + user.role);
    const [countrySelected, setCountrySelected] = useState({ name: "countryCode", label: (user.countryName), value: user.countryCode });
    const [companyGroupSelected, setCompanyGroupSelected] = useState(user.userType);
    const [timezoneSelected, setTimezoneSelected] = useState({ name: "userTimeZone", label: (user.userTimeZone), value: user.userTimeZone });
    const [companySelected, setCompanySelected] = useState({ name: "companyId", label: (user.companyName ? (user.companyName + ', ' + (user.companyCity ? user.companyCity + ', ' : '') + user.companyStateCode + ', ' + user.companyCountryCode) : ""), value: user.companyId });
    const [userSubTypeSelected, setUserSubTypeSelected] = useState({ name: "userSubType", label: (user.userSubType), value: user.userSubType });

    const [countryLoaded, setCountryLoaded] = useState(false);
    const [stateLoaded, setStateLoaded] = useState(false);
    const [timezoneLoaded, setTimezoneLoaded] = useState(false);
    const [companyLoaded, setCompanyLoaded] = useState(false);
    const [userSubTypeLoaded, setUserSubTypeLoaded] = useState(false);

    const submitText = t("page.submit");
    const closeText = t("page.close");
    const canTakeCorrectiveActionRef = useRef(null);
    const [isCanTakeCorrectiveAction, setIsCanTakeCorrectiveAction] = useState(user.canTakeCorrectiveAction);

    // set password which is not used anywhere
    const initialValues = {
        userId: user.userId,
        userName: user.userName,
        password: "",
        password1: "",
        email: user.email,
        address1: user.address1,
        address2: user.address2,
        phone: user.phone,
        zipCode: user.zipCode,
        zipExt: user.zipExt,
        city: user.city,
        stateKey: user.stateKey,
        stateCode: user.stateCode,
        stateName: user.stateName,
        countryCode: user.countryCode,
        countryName: user.countryName,
        interestKey: user.interestKey,
        roleKey: user.roleKey,
        roleCode: user.role,
        appAccess: user.appAccess,
        userTimeZone: user.userTimeZone,
        userLanguage: user.userLanguage,
        updatedById: userCtx.loggedInUserId,
        companyId: user.companyId,
        userType: user.userType,
        userSubType: user.userSubType,
        firstName: user.firstName,
        lastName: user.lastName,
        deviceAccess: user.deviceAccess,
        canTakeCorrectiveAction: user.canTakeCorrectiveAction,
    };
    const [formValues, setFormValues] = useState(initialValues);
    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;

    useEffect(() => {
        fetchCountries();
        fetchStates();
        fetchInterests();
        fetchTimezones();
        fetchCompanyGroups();
        fetchCompanies();
        fetchUserSubTypes();
        scrollToTop();
    }, []);

    function setCountryValues(countryObj) {
        let countryOptionValue = {};
        countryOptions = [];
        countryOptions.push({ label: "", value: "" });
        if (countryObj && countryObj.length > 0) {
            countryObj.map((country, index) => {
                countryOptionValue.label = country.countryName;
                countryOptionValue.value = country.countryCode;
                countryOptions.push(countryOptionValue);
                countryOptionValue = {};
            });
            setCountryLoaded(true);
        }

    }
    function setStateValues(stateObj, countryCode, defDataLoad) {
        let stateValue = {};
        stateOptions = [];
        stateOptions.push({ label: "", value: "0-" });
        if (stateObj && stateObj.length > 0) {
            stateObj.map((state, index) => {
                if (state.countryCode === countryCode) {
                    stateValue.label = state.name;
                    stateValue.value = state.stateKey + "-" + state.stateCode;
                    stateOptions.push(stateValue);
                    stateValue = {};
                }

            });
            setStateLoaded(true);
            if (!defDataLoad) {
                setStateSelected({ ...stateSelected, label: "", value: "0-" });
            }

        }
    }
    function setTimezoneValues(timezoneObj) {
        let timezoneValue = {};
        timezoneOptions = [];
        timezoneOptions.push({ label: "", value: "" });
        if (timezoneObj && timezoneObj.length > 0) {
            timezoneObj.map((timezone, index) => {
                timezoneValue.label = timezone.timezone;
                timezoneValue.value = timezone.timezone;
                timezoneOptions.push(timezoneValue);
                timezoneValue = {};


            });
            setTimezoneLoaded(true);
        }
    }
    function setCompanyValues(companyObj, companyGroup) {
        let companyValue = {};
        companyOptions = [];
        companyOptions.push({ label: "", value: 0 });
        if (companyObj && companyObj.length > 0) {
            companyObj.map((company, index) => {
                if (company.companyGroup === companyGroup) {
                    companyValue.label = company.companyName + ', ' + (company.city ? company.city + ', ' : '') + company.stateCode + ', ' + company.countryCode;
                    companyValue.value = company.companyId;
                    companyOptions.push(companyValue);
                    companyValue = {};
                }

            });
            setCompanyLoaded(true);
        }
    }

    function setUserSubTypeValues(userSubTypeObj) {
        let userSubTypeValue = {};
        userSubTypeOptions = [];
        if (userSubTypeObj && userSubTypeObj.length > 0) {
            userSubTypeObj.map((userSubType, index) => {
                userSubTypeValue.label = userSubType.typeName;
                userSubTypeValue.value = userSubType.typeName;
                userSubTypeOptions.push(userSubTypeValue);
                userSubTypeValue = {};
            });
            setUserSubTypeLoaded(true);
        }
    }

    function fetchStates() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: true, countryCode: (user.countryCode ? user.countryCode : "US") }),
        };
        try {
            FetchUtil.fetchAPI("MGetAllState", "/Service/StaticHelper/GetAllState", requestOptions, getStatesSuccess, getStatesFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getStatesFail(redirect) {
        setError(t("error.getStateFailed"));
    }
    function getStatesSuccess(responseData) {
        let stateResponse;
        if (responseData) {
            stateResponse = responseData.getStateResponse;
            if (stateResponse && stateResponse.errorCode === "0") {
                setStateValues(stateResponse.states, formValues.countryCode, true);
                setStates([...states, ...stateResponse.states]);
            } else if (stateResponse) {
                setError(t("error.error") + " " + stateResponse.errorMessage);
            }
        }
    }
    function fetchCountries() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web" }),
        };
        try {
            FetchUtil.fetchAPI("MGetCountries", "/Service/StaticHelper/GetCountries", requestOptions, getCountriesSuccess, getCountriesFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getCountriesFail(redirect) {
        setError(t("error.getCountryFailed"));
    }
    function getCountriesSuccess(responseData) {
        let countriesResponse;
        if (responseData) {
            countriesResponse = responseData.getCountriesResponse;
            if (countriesResponse && countriesResponse.errorCode === "0") {
                //setCountries([...countries, ...countriesResponse.countries]);
                setCountryValues(countriesResponse.countries);
            } else if (countriesResponse) {
                setError(t("error.error") + " " + countriesResponse.errorMessage);
            }
        }
    }
    function fetchInterests() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: "false" }),
        };
        try {
            FetchUtil.fetchAPI("MGetInterests", "/Service/StaticHelper/GetInterests", requestOptions, getInterestsSuccess, getInterestsFail);
        } catch (error) {
            setError(error.message);
        }
    }
    function getInterestsFail(redirect) {
        setError(t("error.getInterestFailed"));
    }
    function getInterestsSuccess(responseData) {
        let interestResponse;
        if (responseData) {
            interestResponse = responseData.getInterestResponse;
            if (interestResponse && interestResponse.errorCode === "0") {
                setInterests([...interests, ...interestResponse.interests]);
            } else if (interestResponse) {
                setError(t("error.error") + " " + interestResponse.errorMessage);
            }
        }
    }

    function fetchTimezones() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("MGetTimeZone", "/Service/StaticHelper/GetTimeZones", requestOptions, getTimezonesSuccess, getTimezonesFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getTimezonesFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getTimezoneFailed"));
    }

    function getTimezonesSuccess(responseData) {
        let timezoneResponse;
        if (responseData) {
            timezoneResponse = responseData.getTimeZoneResponse;
            if (timezoneResponse && timezoneResponse.errorCode === "0") {
                //setTimezones([...timezones, ...timezoneResponse.timeZones]);
                setTimezoneValues(timezoneResponse.timeZones);
            } else if (timezoneResponse) {
                setError(t("error.error") + " " + timezoneResponse.errorMessage);
            }
        }
    }
    function fetchCompanyGroups() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web" }),
        };
        try {
            FetchUtil.fetchAPI("MGetAllCompanyGroups", "/Service/StaticHelper/GetCompanyGroups", requestOptions, getCompanyGroupsSuccess, getCompanyGroupsFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getCompanyGroupsFail(redirect) {
        setError(t("error.getEntityFailed"));
    }
    function getCompanyGroupsSuccess(responseData) {
        let companyGroupsResponse;
        if (responseData) {
            companyGroupsResponse = responseData.getCompanyGroupsResponse;
            if (companyGroupsResponse && companyGroupsResponse.errorCode === "0") {
                setCompanyGroups([...companyGroups, ...companyGroupsResponse.companyGroups]);
            } else if (companyGroupsResponse) {
                setError(t("error.error") + " " + companyGroupsResponse.errorMessage);
            }
        }
    }

    function fetchUserSubTypes() {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false }),
        };
        try {
            FetchUtil.fetchAPI("MGetUserSubTypes", "/Service/StaticHelper/GetUserSubTypes", requestOptions, getUserSubTypesSuccess, getUserSubTypesFail);
        } catch (error) {
            setError(error.message);
        }
    }

    function getUserSubTypesFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setError(t("error.getUserSubTypeFailed"));
    }

    function getUserSubTypesSuccess(responseData) {
        let getUserSubTypesResponse;
        if (responseData) {
            getUserSubTypesResponse = responseData.getUserSubTypesResponse;
            if (getUserSubTypesResponse && getUserSubTypesResponse.errorCode === "0") {
                //setUserSubTypes([...userSubTypes, ...getUserSubTypesResponse.userSubTypes]);
                setUserSubTypeValues(getUserSubTypesResponse.userSubTypes);
            } else if (getUserSubTypesResponse) {
                setError(t("error.error") + " " + getUserSubTypesResponse.errorMessage);
            }
        }
    }

    const valueHandler = (e) => {
        const { name, value } = e.target;
        if (typeof value === 'undefined') {
            value = "";
        }
        setFormValues({ ...formValues, [name]: value });
    }
    const onResponseChange = (event) => {
        //console.log(event.target + "  " + event.target.name + " " + event.target.checked);
        const { name, id } = event.target;
        setIsCanTakeCorrectiveAction(event.target.checked);
        setFormValues({ ...formValues, [name]: event.target.checked });
    }

    const countryHandler = (selectedOption, action) => {
        let countryCode = selectedOption ? selectedOption.value : "";
        let countryName = selectedOption ? selectedOption.label : "";
        formValues.countryCode = countryCode;
        setCountrySelected({ ...countrySelected, label: (countryName), value: countryCode });
        setStateValues(states, countryCode, false);
    }

    const stateHandler = (selectedOption, action) => {
        let state = selectedOption ? selectedOption.value : "";
        let stateName = selectedOption ? selectedOption.label : "";
        setStateSelected({ ...stateSelected, label: (stateName), value: state });
        if (state) {
            let stateArr = state.split("-");
            formValues.stateKey = stateArr[0];
            formValues.stateCode = stateArr[1];
        }
    }

    const timezoneHandler = (selectedOption, action) => {
        let timezoneCode = selectedOption ? selectedOption.value : "";
        let timezoneName = selectedOption ? selectedOption.label : "";
        formValues.userTimeZone = timezoneCode;
        setTimezoneSelected({ ...timezoneSelected, label: (timezoneName), value: timezoneCode });
    }

    const roleHandler = (e) => {
        let role = e.target.value;
        setRoleValue(role);
        let roleArr = role.split("-");
        formValues.roleKey = roleArr[0];
        formValues.roleCode = roleArr[1];
    }
    const userTypeHandler = (e) => {
        let companyGroup = e.target.value;
        setCompanyGroupSelected(companyGroup);
        formValues.userType = companyGroup;
        setCompanyValues(companies, companyGroup);
    }

    const userSubTypeHandler = (selectedOption, action) => {
        let userSubType = selectedOption ? selectedOption.value : "";
        let userSubTypeName = selectedOption ? selectedOption.label : "";
        formValues.userSubType = userSubType;
        setUserSubTypeSelected({ ...userSubTypeSelected, label: (userSubType), value: userSubType });
    }
    const companyHandler = (selectedOption, action) => {
        let companyId = selectedOption ? selectedOption.value : 0;
        let companyName = selectedOption ? selectedOption.label : "";
        if (add || (!add && userCtx.hasDeleteAccess && userCtx.hasDeleteAccess === true)) {
            if (!add && (userCtx.hasDeleteAccess && userCtx.hasDeleteAccess === true) && user.companyId !== companyId) {
                if (!window.confirm(t("confirm.change.user.company"))) {
                    return;
                }
            }
            const selectedCompany = companies.find(company => company.companyId == companyId);
            if (selectedCompany) {
                formValues.address1 = (selectedCompany.address1) ? selectedCompany.address1 : "";
                formValues.address2 = (selectedCompany.address2) ? selectedCompany.address2 : "";
                formValues.phone = (selectedCompany.phone) ? selectedCompany.phone : "";
                formValues.zipCode = (selectedCompany.zipCode) ? selectedCompany.zipCode : "";
                formValues.zipExt = (selectedCompany.zipExt) ? selectedCompany.zipExt : "";
                formValues.city = (selectedCompany.city) ? selectedCompany.city : "";
                formValues.stateKey = (selectedCompany.stateKey) ? selectedCompany.stateKey : "";
                formValues.countryCode = (selectedCompany.countryCode) ? selectedCompany.countryCode : "US";
                formValues.stateCode = selectedCompany.stateCode;
                formValues.userTimeZone = selectedCompany.companyTimeZone;
                setCountrySelected({ ...countrySelected, label: (selectedCompany.countryName), value: (selectedCompany.countryCode) });
                setStateSelected({ ...stateSelected, label: (selectedCompany.stateName), value: (selectedCompany.stateKey + '-' + selectedCompany.stateCode) });
                setTimezoneSelected({ ...timezoneSelected, label: (selectedCompany.companyTimeZone), value: (selectedCompany.companyTimeZone) });
            } else {
                formValues.address1 = user.address1;
                formValues.address2 = user.address2;
                formValues.phone = user.phone;
                formValues.zipCode = user.zipCode;
                formValues.zipExt = user.zipExt;
                formValues.city = user.city;
                formValues.stateKey = user.stateKey;
                formValues.countryCode = user.countryCode;
                formValues.stateCode = user.stateCode;
                formValues.userTimeZone = user.userTimeZone;
                setCountrySelected({ ...countrySelected, label: (user.countryName), value: (user.countryCode) });
                setStateSelected({ ...stateSelected, label: (user.stateName), value: (user.stateKey + '-' + user.stateCode) });
                setTimezoneSelected({ ...timezoneSelected, label: (user.userTimeZone), value: (user.userTimeZone) });
            }

        }
        setCompanySelected({ ...companySelected, label: companyName, value: companyId });
        setFormValues({ ...formValues, ["companyId"]: companyId });
    }

    function fetchCompanies() {
        setError("");
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: "false", userCompanyId: userCompanyId }),
        };
        try {
            FetchUtil.fetchAPI("FetchCompanies", "/Service/CompanyService/FetchCompanies", requestOptions, fetchCompaniesSuccess, fetchCompaniesFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function fetchCompaniesFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setError(t("error.companyListNotRetrieved"));
    }
    function fetchCompaniesSuccess(responseData) {
        let fetchCompaniesResponse;
        if (responseData) {
            fetchCompaniesResponse = responseData.fetchCompaniesResponse;
            if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "0") {
                setCompanies(fetchCompaniesResponse.companies.slice());
                setCompanyValues(fetchCompaniesResponse.companies, formValues.userType);
            } else if (fetchCompaniesResponse) {
                setError(t("error.error") + " " + fetchCompaniesResponse.errorMessage);
            }
        }
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSubmit(true);
        const formData = new FormData(event.currentTarget);
        let appNames = ["Customer"];
        for (let entry of formData.entries()) {
            if (entry[0] == "stateKey") {
                let stateArr = entry[1].split("-");
                formValues[entry[0]] = stateArr[0];
                formValues.stateCode = stateArr[1];

            } else if (entry[0] == "roleKey") {
                let roleArr = entry[1].split("-");
                formValues[entry[0]] = roleArr[0];
                formValues.roleCode = roleArr[1];
            } else {
                formValues[entry[0]] = entry[1];
            }
        }
        /* for (let item of multiselectRef.current.getSelectedItems()) {
             appNames.push(item.appName);
         }*/
        formValues.appAccess = appNames;
        if (formValues.lastName) {
            formValues.userName = formValues.firstName.trim() + " " + formValues.lastName.trim();
        } else {
            formValues.userName = formValues.firstName.trim();
        }
        let errors = validateFields();
        setFormErrors(errors);
        if (!errors || errors.length === 0) {
            updateUser();
        } else {
            setIsSubmit(false);
        }

    };
    const validateFields = () => {
        const errors = [];
        if (add) {
            if (!formValues.email) {
                errors.push(t("error.emailReqd"));
            } else {
                if (!emailRegex.test(formValues.email.trim())) {
                    errors.push(t("error.invalidEmail"));
                }
            }
        }
        if (!formValues.firstName) {
            errors.push(t("error.firstNameReqd"));
        }
        if (!formValues.lastName) {
            errors.push(t("error.lastNameReqd"));
        }
        if (!formValues.userName.trim()) {
            errors.push(t("error.userNameReqd"));
        }
        if (!formValues.userSubType.trim()) {
            errors.push(t("error.userTypeReqd"));
        }
        if (!formValues.stateKey) {
            errors.push(t("error.stateReqd"));
        }
        if (formValues.userType !== "CONS" && formValues.companyId == 0) {
            errors.push(t("error.companyReqd"));
        }
        if (formValues.deviceAccess == "1" && !formValues.phone) {
            errors.push(t("error.phoneReqd"));
        }
        return errors;
    };
    const updateUser = () => {
        let action = 2;
        let loginId = user.userId.trim();
        if (add) {
            action = 1;
            loginId = formValues.email.trim();
        }
        let serverParams = {
            loginId: loginId,
            email: loginId,
            customerName: formValues.userName.trim(),
            address1: (formValues.address1) ? formValues.address1.trim() : '',
            address2: (formValues.address2) ? formValues.address2.trim() : '',
            phone: (formValues.phone) ? formValues.phone.trim() : '',
            zipCode: (formValues.zipCode) ? formValues.zipCode.trim() : '',
            zipExt: (formValues.zipExt) ? formValues.zipExt.trim() : '',
            city: (formValues.city) ? formValues.city.trim() : '',
            stateKey: formValues.stateKey,
            interestKey: formValues.interestKey,
            appAccess: formValues.appAccess,
            roleKey: formValues.roleKey,
            roleCode: formValues.roleCode,
            stateCode: formValues.stateCode.trim(),
            countryCode: formValues.countryCode,
            source: "web",
            action: action,
            updatedById: formValues.updatedById,
            userTimeZone: formValues.userTimeZone,
            userLanguage: formValues.userLanguage,
            companyId: formValues.companyId,
            userType: formValues.userType,
            userSubType: formValues.userSubType,
            firstName: formValues.firstName.trim(),
            lastName: formValues.lastName.trim(),
            deviceAccess: parseInt(formValues.deviceAccess),
            canTakeCorrectiveAction: canTakeCorrectiveActionRef.current.checked,
        };
        if (add) {
            serverParams.passwd = formValues.password.trim();
        }
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("UpdateCustomer", "/Service/UserService/AddUpdateCustomer", requestOptions, updateCustomerSuccess, updateCustomerFail);
        } catch (error) {
            setError(error.message);
        }
    };

    function updateCustomerFail(redirect) {
        setIsSubmit(false);
        setError(t("error.userEditFailed"));
    }
    function updateCustomerSuccess(responseData) {
        setIsSubmit(false);
        let addUpdateCustomerResponse;
        if (responseData) {
            addUpdateCustomerResponse = responseData.addUpdateCustomerResponse;
            if (addUpdateCustomerResponse) {
                if (addUpdateCustomerResponse.errorCode === "0" || addUpdateCustomerResponse.errorCode === "23") {
                    setShow(false);
                    refetch();
                    navigate("/pages/users");
                } else {
                    setError(t("error.error") + " " +
                        addUpdateCustomerResponse.errorMessage
                    );
                }
            }
        }
    }

    return (
        <>
            {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                <div className="modalContainer hide-scrollbar">
                    <div className="row">
                        <div className="col mt-3">
                            {((formErrors && formErrors.length > 0) || error) ? (
                                <div id="inerrorMessage" className="errorblock">
                                    {((formErrors && formErrors.length > 0)) ? (
                                        formErrors.map((errorData, index) => (
                                            <p className="message-line">{errorData}</p>
                                        ))
                                    ) : ""}
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <form
                                className="regn_form_container"
                                acceptCharset="UTF-8"
                                id="sign-up"
                                onSubmit={handleSubmit}
                            >
                                <h2>{(add) ? t("header.admin.addUser") : t("page.editUser")}
                                </h2>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label htmlFor="userType" className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.entity")}
                                            </label>
                                            <select name="userType"
                                                className="form-select form-select-sm"
                                                style={{ borderRadius: "5px" }}
                                                onChange={(e) => userTypeHandler(e)}
                                                value={companyGroupSelected}
                                            >
                                                {companyGroups.map((companyGroup) => (
                                                    <option value={companyGroup.groupName}>
                                                        {companyGroup.description}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            {!add ?
                                                (<label>{t("page.id")} : {user.userId} </label>)
                                                :
                                                <label htmlFor="email" className="form-label">
                                                    <span className="form_required">*</span>
                                                    {t("page.email")}
                                                </label>
                                            }
                                            {add ?
                                                <input
                                                    type="text"
                                                    name="email"
                                                    id="email"
                                                    placeholder="Email"
                                                    maxLength="50"
                                                    value={formValues.email}
                                                    onChange={(e) => valueHandler(e)}
                                                    className="form-control rounded-pill border-0 shadow-sm px-4"
                                                /> :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.firstName")}
                                            </label>
                                            <input name="firstName" value={formValues.firstName} maxlength="50"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.lastName")}
                                            </label>
                                            <input name="lastName" value={formValues.lastName} maxlength="50"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.company")}
                                            </label>
                                            {add || (userCtx.hasDeleteAccess && userCtx.hasDeleteAccess === true) ?
                                                <Select
                                                    name="companyId"
                                                    options={companyOptions}
                                                    onChange={companyHandler}
                                                    placeholder={""}
                                                    value={companySelected}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    className="myselect"
                                                    inputId="companyId-input"
                                                    styles={ddStyles}
                                                />
                                                : (user.companyName ? (user.companyName + ', ' + (user.companyCity ? user.companyCity + ', ' : '') + user.companyStateCode + ', ' + user.companyCountryCode) : "")}
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.timezone")}
                                            </label>
                                            <Select
                                                name="userTimeZone"
                                                options={timezoneOptions}
                                                onChange={timezoneHandler}
                                                placeholder={""}
                                                value={timezoneSelected}
                                                isSearchable={true}
                                                isClearable={true}
                                                className="myselect"
                                                inputId="userTimeZone-input"
                                                styles={ddStyles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.country")}
                                            </label>
                                            <Select
                                                name="countryCode"
                                                options={countryOptions}
                                                onChange={countryHandler}
                                                placeholder={defCountryText}
                                                value={countrySelected}
                                                isSearchable={true}
                                                isClearable={true}
                                                className="myselect"
                                                inputId="countryCode-input"
                                                styles={ddStyles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.address1")}
                                            </label>
                                            <input name="address1" value={formValues.address1} maxlength="40"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.address2")}
                                            </label>
                                            <input name="address2" value={formValues.address2} maxlength="40"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.city")}
                                            </label>
                                            <input name="city" value={formValues.city} maxlength="40"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.state")}
                                            </label>
                                            <Select
                                                name="stateKey"
                                                options={stateOptions}
                                                onChange={stateHandler}
                                                placeholder={""}
                                                value={stateSelected}
                                                isSearchable={true}
                                                isClearable={true}
                                                className="myselect"
                                                inputId="stateKey-input"
                                                styles={ddStyles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-2 col-3">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.zipCode")}
                                            </label><input name="zipCode" value={formValues.zipCode}
                                                maxlength="12"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col-xs-2 col-3">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.zipExt")}
                                            </label>
                                            <input name="zipExt" value={formValues.zipExt}
                                                maxlength="4"
                                                className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.phone")}
                                            </label>
                                            <input name="phone" value={formValues.phone}
                                                maxlength="15" className="form-control rounded-pill border-0 shadow-sm px-4"
                                                onChange={(e) => valueHandler(e)} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.language")}
                                            </label>
                                            <select name="userLanguage"
                                                className="form-select form-select-sm"
                                                style={{ borderRadius: "5px" }}
                                                onChange={(e) => valueHandler(e)}
                                                value={formValues.userLanguage}>
                                                <option value="ar">
                                                    {t("page.arabic")}
                                                </option>
                                                <option value="en">
                                                    {t("page.english")}
                                                </option>
                                                <option value="fr">
                                                    {t("page.french")}
                                                </option>
                                                <option value="sr">
                                                    {t("page.serb.cyrl")}
                                                </option>
                                                <option value="es">
                                                    {t("page.spanish")}
                                                </option>
                                                <option value="tr">
                                                    {t("page.turkish")}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.interests")}
                                            </label>
                                            <select name="interestKey"
                                                className="form-select form-select-sm"
                                                style={{ borderRadius: "5px" }}
                                                onChange={(e) => valueHandler(e)}
                                                value={formValues.interestKey}>
                                                <option />
                                                {interests.map((interest) => (
                                                    <option
                                                        value={interest.interestKey}
                                                    >
                                                        {interest.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.role")}
                                            </label>
                                            <select name="roleKey"
                                                className="form-select form-select-sm"
                                                style={{ borderRadius: "5px" }}
                                                onChange={(e) => roleHandler(e)}
                                                value={roleValue}>
                                                {roles.map((role) => (
                                                    <option
                                                        value={role.roleKey + "-" + role.roleCode}
                                                    >
                                                        {role.description}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                <span className="form_required">*</span>
                                                {t("page.userType")}
                                            </label>
                                            <Select
                                                name="userSubType"
                                                options={userSubTypeOptions}
                                                onChange={userSubTypeHandler}
                                                placeholder={""}
                                                value={userSubTypeSelected}
                                                isSearchable={true}
                                                isClearable={true}
                                                className="myselect"
                                                inputId="userSubType-input"
                                                styles={ddStyles}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-2 col-3">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.deviceAccess")}
                                            </label>
                                            <select name="deviceAccess"
                                                className="form-select form-select-sm"
                                                style={{ borderRadius: "5px" }}
                                                onChange={(e) => valueHandler(e)}
                                                value={formValues.deviceAccess}>
                                                <option value="0">
                                                    {t("page.no")}
                                                </option>
                                                <option value="1">
                                                    {t("page.yes")}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <label className="form-label">
                                                {t("page.canTakeCorrectiveAction")}
                                            </label>
                                            <input type="checkbox" className="mycheckbox"
                                                ref={canTakeCorrectiveActionRef}
                                                name={"canTakeCorrectiveAction"}
                                                id={"canTakeCorrectiveAction"}
                                                defaultChecked={false}
                                                checked={isCanTakeCorrectiveAction}
                                                onChange={onResponseChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="footer">
                                    <input
                                        type="button"
                                        name="edit-user-close"
                                        id="edit-user-close"
                                        className="btn btn-secondary btn-block" data-dismiss="modal"
                                        disabled={isSubmit}
                                        onClick={(e) => setShow(false)}
                                        style={{ marginRight: "50px" }}
                                        value={closeText}
                                    ></input>

                                    <div id="submit-spinner"
                                        className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                                    >  </div>
                                    <input
                                        type="submit"
                                        name="edit-submit"
                                        id="edit-submit"
                                        data-dismiss="modal"
                                        className={"btn btn-primary btn-block"}
                                        style={{ marginTop: "10px", marginBottom: "10px" }}
                                        value={submitText}
                                        disabled={isSubmit}
                                    >
                                    </input>

                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col mt-3">
                            {((formErrors && formErrors.length > 0) || error) ? (
                                <div id="berrorMessage" className="errorblock">
                                    {((formErrors && formErrors.length > 0)) ? (
                                        formErrors.map((errorData, index) => (
                                            <p className="message-line">{errorData}</p>
                                        ))
                                    ) : ""}
                                    {error}
                                </div>
                            ) : (<></>)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg" style={{ height: "10px" }}></div>
                        </div>
                    </div>
                </div>
                : null}
        </>
    );
}

export default UserModal;